@if ((energyBonuses | async)?.length <= 0) {
    <ap-spinner
        [visuallyHiddenLabel]="true"
        loadingText="{{ 'property.energy-label.spinner.loading' | apContent }}"
        readyText="{{ 'property.energy-label.spinner.ready' | apContent }}"
        state="loading"
        [size]="'medium'"
        [icon]="true"
    ></ap-spinner>
} @else {
    <div class="ap-margin-bottom-3">
        <ap-content
            [key]="contentLabel | coApplicantPipe: store.hasCoApplicant"
            [params]="{
                energyLabel: propertyType | energyLabelPipe | apContent
            }"
        >
        </ap-content>
    </div>
    <ap-radio-group
        [control]="mainApplicantControl"
        id="energyLabelRadioButton"
        description="energielabel selecteren"
        [descriptionHidden]="true"
    >
        @for (bonus of energyBonuses | async; track bonus) {
            <div class="ap-flex ap-padding-1" [ngClass]="isSelected(bonus.energy_label) ? 'radio_selected' : 'radio_unselected'">
                <div class="ap-margin-top-3 ap-margin-right-5 ap-width-0">
                    <ap-radio-button
                        name="mainApplicantControl"
                        [value]="bonus?.energy_label"
                        [ariaDescribedby]="bonus?.energy_label"
                        [formControl]="mainApplicantControl"
                        label=""
                    ></ap-radio-button>
                </div>
                <div class="ap-flex ap-flex-basis-75 ap-flex-row ap-flex-gap-1">
                    <div aria-label="svgUrl" [apInlineSVG]="getSvgUrl(bonus.energy_label)"></div>
                    @if (hasHint(bonus.energy_label)) {
                        <div class="ap-padding-top-1 ap-flex-fill">
                            <additional-info
                                class="text-primary"
                                [type]="hintType.LINK"
                                [key]="questionKey"
                                titleKey="epg.additional-info.title"
                                contentKey="epg.additional-info.content"
                                modalUrlKey="epg.additional-info.url"
                            >
                            </additional-info>
                        </div>
                    }
                </div>

                <div class="ap-width-50 ap-text-align-right ap-margin-top-1" [ngClass]="{ bold: isSelected(bonus.energy_label) }">
                    +
                    <ap-amount-display
                        [minFractionDigits]="0"
                        [maxFractionDigits]="0"
                        [value]="bonus.amount?.amount"
                        [emphasize]="isSelected(bonus.energy_label)"
                    ></ap-amount-display>
                </div>
            </div>
        }
    </ap-radio-group>
    <additional-info
        [key]="questionKey"
        titleKey="property.energy-label.select.additional-info.text"
        contentKey="property.energy-label.select.additional-info.content"
        modalUrlKey="property.energy-label.select.additional-info.text"
    ></additional-info>

    @if (!store.isSummary) {
        <next-button (click)="nextQuestion()"></next-button>
    }
}
